import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Ruler.png'
import _imports_1 from '@/assets/images/Globe.png'
import _imports_2 from '@/assets/images/PolicyIcon.png'
import _imports_3 from '@/assets/images/EnergyIcon.png'
import _imports_4 from '@/assets/images/SatIcon.png'
import _imports_5 from '@/assets/images/AntennaIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-493f0bf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "globe" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "ruler"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    title: "globe",
    src: _imports_1,
    alt: "globe"
  })
], -1))
const _hoisted_3 = { class: "right_icons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "PolicyIcon"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "energyIcon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "satIcon"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "antennaIcon"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"bottom_text\" data-v-493f0bf5><div class=\"bottom_text_left\" data-v-493f0bf5><p class=\"bottom_text_bold\" data-v-493f0bf5> OREUM SAT </p><p class=\"bottom_text_regular\" data-v-493f0bf5> Microsatellite for Earth Observation<br data-v-493f0bf5>and FSO Communication </p></div><div class=\"bottom_text_center\" data-v-493f0bf5><p class=\"bottom_text_bold\" data-v-493f0bf5> COPY RIGHT </p><p class=\"bottom_text_regular\" data-v-493f0bf5> CONTEC Co., Ltd. all right reserved </p></div><div class=\"bottom_text_right\" data-v-493f0bf5><p class=\"bottom_text_bold\" data-v-493f0bf5> LAUNCH INFO </p><p class=\"bottom_text_regular\" data-v-493f0bf5>CALIFORNIA. Vandenberg Space Force Base<br data-v-493f0bf5>SPACE X TR-10 / SLC-4E launch pad </p></div></div>", 1)

import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundImages',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const { LicenseModalToggle } = useCommonStore();

return (_ctx: any,_cache: any) => {
  return (!_unref(isImageMode))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(LicenseModalToggle) && _unref(LicenseModalToggle)(...args)))
          }, _hoisted_5),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _hoisted_9
      ]))
    : _createCommentVNode("", true)
}
}

})